import {useClientsContext} from '../../../context/clients/ClientsContextProvider';
import {
  ScreenTypes,
  useUsersScreenContext,
} from '../../../context/users/UsersScreenContextProvider';
import {hasPermission} from '../../../utils';

function UserHeader() {
  const {selectedScreen, setSelectedScreen} = useUsersScreenContext();
  const {selectedLocation} = useClientsContext();

  const SCREENS = [
    {screen: 'users', label: 'משתמשים'},
    ...(hasPermission('manage_permissions')
      ? [{screen: 'roles', label: 'תפקידים'}]
      : []),
    {screen: 'groups', label: 'קבוצות'},
  ];

  const handleChangeScreen = (screen: ScreenTypes) => {
    setSelectedScreen(screen);
  };

  return (
    <div className="w-full bg-white px-4 shadow-md z-[2]">
      <div className="w-full h-full flex items-center">
        <div className="flex items-center gap-2 min-w-[400px]">
          <span className="text-2xl font-semibold leading-6 text-black">
            ניהול משתמשים
          </span>
          <span className="text-2xl leading-6 text-deepAqua">&gt;</span>
          <span className="text-2xl font-semibold leading-6 text-deepAqua">
            {selectedLocation?.name ?? ''}
          </span>
        </div>

        <div className="flex-1 flex justify-center items-center gap-2">
          {SCREENS.map((scr, index) => {
            const isCurrent = scr.screen == selectedScreen;

            return (
              <button
                key={index}
                className={`p-4 text-sm
              ${
                isCurrent
                  ? 'border-b-[3px] border-b-deepAqua font-semibold text-black'
                  : 'text-darkerGray'
              }
              `}
                onClick={() => handleChangeScreen(scr?.screen as ScreenTypes)}>
                {scr?.label}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default UserHeader;
